import request from '@/utils/request';

export function getQrcode(params) {
  return request({
    url: '/api/external/epoint/bzt/qrcode',
    method: 'get',
    params,
  });
}

export function getQueryResult(params) {
  return request({
    url: '/api/external/epoint/bzt/queryResult',
    method: 'get',
    params,
  });
}

export default { getQrcode, getQueryResult };
